import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrowsePageService_GetBrowseCategoriesLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.grpc.lazy';
import {useAnySession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';

export const useGetCategoryTiles = () => {
  const session = useAnySession();
  const targetGroup = useTargetGroupIdentifier();
  const reductionsState = useReductionsStateRequestParameter();

  return useGrpcRequest(
    BrowsePageService_GetBrowseCategoriesLazy,
    {
      session,
      targetGroup,
      reductionsState,
    },
    {
      keepPreviousData: true,
    },
  );
};
